export const getP = function (data) {
  var provinces = []
  data.forEach(item => {
    if (item.province) {
      if (provinces.indexOf(item.province) === -1) {
        provinces.push(item.province)
      }
    }
  })
  return provinces
}

export const getC = function (pro, data) {
  var city = []
  data.forEach(item => {
    if (item.city) {
      if (city.indexOf(item.city) === -1 && item.province === pro) {
        city.push(item.city)
      }
    }
  })
  city.unshift('不限')
  return city
}

export const getT = function (pro, city, data) {
  var town = []
  data.forEach(item => {
    if (item.town) {
      if (town.indexOf(item.town) === -1 && item.province === pro && item.city === city) {
        town.push(item.town)
      }
    }
  })
  town.unshift('不限')
  return town
}
